import { useEffect, useRef, useState } from 'react';
import { LayoutLearning } from '../../../components';
import { Tlearning, initialLearning } from '../../../type/learning';
import { useNavigate, useParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { formatDuration } from '../../../utls/date';
import { getDataDetail } from '../../../service/learningUsersService';
import { trackWatch } from '../../../service/learningUsersVideoService';
import { getPostTestResult } from '../../../service/postTestService';
import { TlearningAssetsVideo } from '../../../type/learningAssetsVideo';
import { TPostTestResult } from '../../../type/postTest';
import { MINIO } from '../../../data/data';
import axios from 'axios';
import fileDownload from 'js-file-download';

const LearningProsess = () => {
	const navigate = useNavigate();
	const [learning, setLearning] = useState<Tlearning>(initialLearning);
	const [back, setBack] = useState<boolean>(true);
	const [duration, setDuration] = useState(0);
	const [title, setTitle] = useState('');
	const [selectedLearningItem, setSelectedLearningItem] = useState<
		TlearningAssetsVideo | undefined
	>();

	const [isExpanded, setExpanded] = useState(false);

	// null = belum pernah dikerjakan, undefined = belum dicek / tidak ada post test
	const [postTestStatus, setPostTestStatus] = useState<
		TPostTestResult | null | undefined
	>(undefined);
	const [checkingPostTestStatus, setCheckingPostTestStatus] = useState(false);

	const watchedVideoIds = useRef<Set<string>>(new Set());

	const { slug } = useParams();

	const getDataLearningDetail = async (slug: string) => {
		const response = await getDataDetail(slug);
		if (!response?.error) {
			setLearning(response?.data.learning);
			if (response?.data.learning.learningAssetsVideos.length > 0) {
				setSelectedLearningItem(
					response?.data.learning.learningAssetsVideos[0]
				);
			}
		}
	};

	const markVideoOpened = () => {
		const videoUniqueId = selectedLearningItem?.uniqueId;
		if (!learning.uniqueId || !videoUniqueId || watchedVideoIds.current.has(videoUniqueId)) {
			return;
		}
		watchedVideoIds.current.add(videoUniqueId);
		trackWatch({
			learningUniqueId: learning.uniqueId,
			learningAssetsVideoUniqueId: videoUniqueId,
			isCompleted: false,
		});
	};

	const markVideoCompleted = (watchedDuration: number) => {
		const videoUniqueId = selectedLearningItem?.uniqueId;
		if (!learning.uniqueId || !videoUniqueId) {
			return;
		}
		trackWatch({
			learningUniqueId: learning.uniqueId,
			learningAssetsVideoUniqueId: videoUniqueId,
			isCompleted: true,
			duration: Math.round(watchedDuration),
		});
	};

	const downloadFile = async (fileName: string) => {
		axios({
			url: `${MINIO}/${fileName}`,
			method: 'GET',
			responseType: 'blob', // Important
		}).then((response) => {
			fileDownload(response.data, fileName);
		});
	};

	const goToPostTest = () => {
		if (!selectedLearningItem?.uniqueId) {
			return;
		}
		navigate(`/admin/learning/post-test/${selectedLearningItem.uniqueId}`);
	};

	useEffect(() => {
		getDataLearningDetail(slug || '');
	}, []);

	useEffect(() => {
		setPostTestStatus(undefined);

		if (!selectedLearningItem?.uniqueId || !selectedLearningItem?.postTest) {
			return;
		}

		const checkStatus = async () => {
			setCheckingPostTestStatus(true);
			const response = await getPostTestResult(selectedLearningItem.uniqueId as string);
			setCheckingPostTestStatus(false);

			if (response?.error) {
				return;
			}

			setPostTestStatus(response.data ?? null);
		};

		checkStatus();
	}, [selectedLearningItem?.uniqueId]);

	const opts = {
		height: '300',
		width: '100%',
		playerVars: {
			controls: 1,
			rel: 0,
			autoplay: 1,
		},
	};

	const toggleExpand = () => {
		setExpanded(!isExpanded);
	};

	return (
		<LayoutLearning btnBack={back}>
			{learning.learningAssetsVideos.length > 0 && (
				<div className="max-w-[480px] overflow-hidden">
					<YouTube
						className=""
						onPlay={() => {
							setBack(false);
							markVideoOpened();
						}}
						onReady={(event: any) => {
							setDuration(event.target.getDuration());
						}}
						onPause={() => {
							setBack(true);
						}}
						onEnd={(event: any) => {
							markVideoCompleted(event.target.getDuration());
						}}
						opts={opts}
						onPlaybackRateChange={() => { }}
						videoId={selectedLearningItem?.youtubeId}
					/>
				</div>
			)}

			<div className="mx-4 mt-[1rem] background-img">
				<h1 className="text-[14px]">{title}</h1>
				<div className="flex items-center justify-between text-[12px] text-sky-600 my-[.5rem]">
					<div className="flex items-center gap-2">
						<DynamicFaIcon name={'FaVolumeHigh'} />
						<span className="">{learning.author}</span>
					</div>
					<div>{formatDuration(duration)}</div>
				</div>
				<div></div>
				<div
					className={`bg-gray-100 px-4 py-2 rounded-sm panel-description ${isExpanded ? 'expanded' : ''
						}`}
				>
					<div
						onClick={toggleExpand}
						className="cursor-pointer flex items-start justify-between"
					>
						<div>
							<h2 className="text-[13px] font-bold block">
								{selectedLearningItem?.name}
							</h2>
							{/* <span className="text-[11px] text-gray-400">
								{selectedLearningItem.learningCategory.name}
							</span> */}
						</div>
						<div className="flex items-center gap-4">
							{selectedLearningItem?.attachment && (
								<DynamicFaIcon name={'FaPaperclip'} />
							)}
							{isExpanded ? (
								<DynamicFaIcon name={'FaAngleUp'} />
							) : (
								<DynamicFaIcon name={'FaAngleDown'} />
							)}
						</div>
					</div>
					<div className="border my-3" />
					<div className="">
						<p className="font-semibold">Deskripsi</p>
						<div
							className="line-clamp-[10] mb-[1rem]"
							dangerouslySetInnerHTML={{
								__html: selectedLearningItem?.content || '',
							}}
						/>
						<p className="font-semibold">Attachment</p>
						<p>
							{selectedLearningItem?.attachment ? (
								<a
									onClick={() =>
										downloadFile(selectedLearningItem?.attachment || '')
									}
								>
									{selectedLearningItem?.attachment}
								</a>
							) : (
								'-'
							)}
						</p>
					</div>
				</div>

				{selectedLearningItem?.postTest && (
					<div
						onClick={goToPostTest}
						className="mt-3 flex items-center justify-between px-4 py-3 rounded-sm bg-sky-50 border border-sky-200 cursor-pointer"
					>
						<div>
							<p className="text-[13px] font-semibold text-sky-700">
								{checkingPostTestStatus
									? 'Memeriksa status...'
									: postTestStatus
										? 'Post Test sudah dikerjakan'
										: 'Kerjakan Post Test'}
							</p>
							{postTestStatus && (
								<p className="text-[11px] text-gray-500">
									{postTestStatus.correctCount} dari{' '}
									{postTestStatus.totalQuestions} jawaban benar
								</p>
							)}
						</div>
						{postTestStatus ? (
							<span className="text-[16px] font-bold text-sky-600">
								{Math.round(postTestStatus.score)}%
							</span>
						) : (
							<DynamicFaIcon name={'FaAngleRight'} />
						)}
					</div>
				)}

				<div>
					<ul>
						{learning.learningAssetsVideos.map(
							(items: TlearningAssetsVideo, index: number) => {
								return (
									<li
										key={index}
										onClick={() => {
											setSelectedLearningItem(items);
											// setYoutubeId(items.youtubeId);
											// setTitle(items.name);
										}}
										className="cursor-pointer flex gap-2 items-center p-2 my-2 bg-gray-200 rounded-sm"
									>
										<i className="text-red-800">
											<DynamicFaIcon name={'FaYoutube'} />
										</i>
										<span>{items.name}</span>
									</li>
								);
							}
						)}
					</ul>
				</div>
			</div>
		</LayoutLearning>
	);
};

export default LearningProsess;
